import React, {useEffect, useRef} from "react"
import styled from "styled-components"

import {H2, Body} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/recognition/recognition"

import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Flex from "@irati/ui/src/Flex"
import {GroupCelebration} from "@irati/types"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import addMessageSuccess from "../../../images/addMessage.svg"
import {RecognitionRoutes} from "../../../enums/Routes"

const Image = styled.img`
  height: 100px;
  margin-bottom: 15px;
  width: auto;
`
interface Props extends InjectIntlProps {
  timeoutMilliseconds?: number
  scheduledGroupCelebration: GroupCelebration
  onHide?: () => void
  onViewCelebration?: () => void
  isEdit?: boolean
}
const SuccessMessage: React.FC<Props> = (props) => {
  const {formatMessage, scheduledGroupCelebration, onHide, isEdit, onViewCelebration, timeoutMilliseconds = 30000} = props
  const closeSuccessTimeout = useRef(-1)
  useEffect(() => {
    tracking.recognitionConfirmation({type: "scheduled", source: "greeting_card_add_message"})
    closeSuccessTimeout.current = setTimeout(onHide, timeoutMilliseconds)
    return () => {
      clearTimeout(closeSuccessTimeout.current)
    }
  }, [])
  const inviteOthers = () => {
    tracking.recognitionCtaClick({
      source: "confirmation_modal",
      type: "greeting_card_invite_others"
    })
  }
  const goToCelebrationList = () => {
    tracking.recognitionCtaClick({
      source: "confirmation_modal",
      type: "greeting_card_view_group_celebration"
    })
    onViewCelebration?.()
  }
  const headerIntlKey = isEdit
    ? "recognition.scheduledGroupCelebration.successMessageEdited.header"
    : "recognition.scheduledGroupCelebration.successMessage.header"
  const bodyIntlKey = isEdit
    ? "recognition.scheduledCelebration.successMessageEdited.body"
    : "recognition.scheduledCelebration.successMessage.body"
  return (
    <Flex direction="column" gap={3}>
      <H2 textAlign="center">
        <FormattedMessage id={headerIntlKey} />
      </H2>
      <Image alt={formatMessage({id: "recognition.popup.createGroupCelebrationMessage.success.image"})} src={addMessageSuccess} />
      <Body small textAlign="center">
        <FormattedMessage id={bodyIntlKey} />
      </Body>
      <Flex direction="column" gap={2}>
        <ButtonRouterLink
          primary
          full
          scrollToTop={false}
          plain
          to={`${RecognitionRoutes.ACCOUNT}/my-group-celebrations/${scheduledGroupCelebration.uuid}`}
          onClick={goToCelebrationList}>
          <FormattedMessage id="recognition.createScheduledGroupCelebration.success.viewGroupCelebration" />
        </ButtonRouterLink>
        <ButtonRouterLink
          scrollToTop={false}
          plain
          full
          to={`${RecognitionRoutes.ACCOUNT}/my-group-celebrations/${scheduledGroupCelebration.uuid}/invite`}
          onClick={inviteOthers}>
          <FormattedMessage id="recognition.createScheduledGroupCelebration.success.inviteOthers" />
        </ButtonRouterLink>
      </Flex>
    </Flex>
  )
}

export default injectIntl(SuccessMessage)
